import { RootState } from '../../store';

export const getCustomerErrorsSelector = (state: RootState) => state?.ticketReducer?.newCustomerErrors;
